async function request(path, customConfig = {}) {
  const headers = {
    'Content-Type': 'application/json',
    'X-Requester': 'Embedded 2.0',
  };
  const config = {
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  function parseJSON(response) {
    return new Promise((resolve, reject) =>
      response
        .json()
        .then(json => {
          return resolve({
            status: response.status,
            ok: response.ok,
            json,
          });
        })
        .catch(() => {
          const error = new Error(response.statusText);
          error.response = response;

          return reject(error);
        }),
    );
  }

  return new Promise((resolve, reject) => {
    fetch(path, config)
      .then(parseJSON)
      .then(response => {
        if (response.ok) {
          return resolve(response.json);
        }

        return reject(response.json);
      })
      .catch(err => reject(err));
  });
}

export { request };
